export default __webpack_public_path__ + "static/media/Linkedin-logo.e4abe6e6.svg";